import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';

import DynamicSelect from '../resources/DynamicSelect';
import * as Constants from '../../components/api/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Box from '@mui/material/Box';

import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';

import Tooltip from '@mui/material/Tooltip';

const modeData = [
  { id: '1', name: 'NORM' },
  { id: '2', name: 'ECON' },
  { id: '3', name: 'AWAY' },
  { id: '4', name: 'WEEK' },
];

const filtData = Array.from({ length: 24 }, (_, i) => ({
  id: (i + 1).toString(),
  name: (i + 1).toString(),
}));

const timeData = [
  { id: '1', name: '00:00' },
  { id: '2', name: '00:30' },
  { id: '3', name: '01:00' },
  { id: '4', name: '01:30' },
  { id: '5', name: '02:00' },
  { id: '6', name: '02:30' },
  { id: '7', name: '03:00' },
  { id: '8', name: '03:30' },
  { id: '9', name: '04:00' },
  { id: '10', name: '04:30' },
  { id: '11', name: '05:00' },
  { id: '12', name: '05:30' },
  { id: '13', name: '06:00' },
  { id: '14', name: '06:30' },
  { id: '15', name: '07:00' },
  { id: '16', name: '07:30' },
  { id: '17', name: '08:00' },
  { id: '18', name: '08:30' },
  { id: '19', name: '09:00' },
  { id: '20', name: '09:30' },
  { id: '21', name: '10:00' },
  { id: '22', name: '10:30' },
  { id: '23', name: '11:00' },
  { id: '24', name: '11:30' },
  { id: '25', name: '12:00' },
  { id: '26', name: '12:30' },
  { id: '27', name: '13:00' },
  { id: '28', name: '13:30' },
  { id: '29', name: '14:00' },
  { id: '30', name: '14:30' },
  { id: '31', name: '15:00' },
  { id: '32', name: '15:30' },
  { id: '33', name: '16:00' },
  { id: '34', name: '16:30' },
  { id: '35', name: '17:00' },
  { id: '36', name: '17:30' },
  { id: '37', name: '18:00' },
  { id: '38', name: '18:30' },
  { id: '39', name: '19:00' },
  { id: '40', name: '19:30' },
  { id: '41', name: '20:00' },
  { id: '42', name: '20:30' },
  { id: '43', name: '21:00' },
  { id: '44', name: '21:30' },
  { id: '45', name: '22:00' },
  { id: '46', name: '22:30' },
  { id: '47', name: '23:00' },
  { id: '48', name: '23:30' },
];

const ddisData = [
  { id: '1', name: 'WTMP' },
  { id: '2', name: 'STMP' },
  { id: '3', name: 'TIME' },
];

const toutData = [];
let t = 10;
let toutId = 1;
while (t <= 60) {
  toutData.push({ id: toutId++, name: t.toString() });
  t++;
}

const hpmpData = [
  { id: '1', name: 'Auto' },
  { id: '2', name: 'Heat only' },
  { id: '3', name: 'Cool only' },
  { id: '4', name: 'Off' },
];

const onoffData = [
  { id: '1', name: 'On' },
  { id: '2', name: 'Off' },
];

const daysData = [
  { id: '1', name: 'Disabled' },
  { id: '2', name: 'Week' },
  { id: '3', name: 'Weekday' },
  { id: '4', name: 'Weekend' },
  { id: '5', name: 'Monday' },
  { id: '6', name: 'Tuesday' },
  { id: '7', name: 'Wednesday' },
  { id: '8', name: 'Thursday' },
  { id: '9', name: 'Friday' },
  { id: '10', name: 'Saturday' },
  { id: '11', name: 'Sunday' },
];

const runTimerDaysData = [
  { id: '128', name: 'Disabled' },
  { id: '127', name: 'Every Day (Mon-Sun)' },
  { id: '62', name: 'Weekdays (Mon-Fri)' },
  { id: '65', name: 'Weekends (Sat-Sun)' },
  { id: '30', name: 'Mon-Thu' },
  { id: '97', name: 'Fri-Sun' },
  { id: '2', name: 'Monday' },
  { id: '4', name: 'Tuesday' },
  { id: '8', name: 'Wednesday' },
  { id: '16', name: 'Thursday' },
  { id: '32', name: 'Friday' },
  { id: '64', name: 'Saturday' },
  { id: '1', name: 'Sunday' },
];

const powersaveData = [
  { id: '1', name: 'Off' },
  { id: '2', name: 'Low' },
  { id: '3', name: 'High' },
];

const lockModeData = [
  { id: '1', name: 'Off' },
  { id: '2', name: 'Partial' },
  { id: '3', name: 'Full' },
];

const USER_MENU_TOOLTIPS = {
  MODE: 'Operation Mode',
  FILT: 'Filtration (hours)',
  WCLN: 'Sanitise Start Time',
  'D.DIS': 'Default display mode',
  'T.OUT': 'Time Out Period',
  'H.PMP': 'Heat Pump Mode',
  'H.ELE': 'Heat Pump Element Boost',

  Days: 'Active Days',
  Begin: 'Start Time',
  End: 'End Time',

  'Begin ': 'Peak Power Period Begins',
  'End ': 'Peak Power Period Ends',

  Level: 'Power Save Level',
  'Lock Mode': 'Keylock Mode',
};

export default function EEPROMUserMenu() {
  const { state } = useContext(MainContext);
  const r4 = state.R4.split(',');
  const r6 = state.R6.split(',');
  const r7 = state.R7.split(',');
  const rg = state.RG.split(',');
  const deviceId = state.selectedDevice;
  const rh = state.RH ? state.RH.split(',') : [];
  const hasRunTimers = (rh.length > 1 && rh[1] !== undefined) || (rh.length >= 23 && rh[23] !== '1');

  const getTimer = (n, d, b, e) => ({
    show: true,
    days: rh[d],
    bgn: rh[b],
    end: rh[e],
  });

  const timers = {
    1: getTimer(1, 1, 2, 3),
    2: getTimer(2, 4, 5, 6),
    3: getTimer(3, 7, 8, 9),
    4: getTimer(4, 10, 11, 12),
    5: getTimer(5, 13, 14, 15),
    6: getTimer(6, 16, 17, 18),
    7: getTimer(7, 19, 20, 21),
  };

  const runTimerRows = hasRunTimers
    ? Object.entries(timers)
      .filter(([_, t]) => t.show)
      .flatMap(([n, t]) => {
        const base = `rt${n}`;

        return [
          {
            id: `${base}days`,
            section: `Run Timer ${n}`,
            label: 'Days',
            current: getRunTimerEnabledLabel(n, rh) === 'Disabled'
              ? 'Disabled'
              : parseRunDays(t.days),
            selectData: runTimerDaysData,
            command: base,
          },
          {
            id: `${base}bgn`,
            section: `Run Timer ${n}`,
            label: 'Begin',
            current: ConvertTime(t.bgn),
            selectData: timeData,
            command: base,
          },
          {
            id: `${base}end`,
            section: `Run Timer ${n}`,
            label: 'End',
            current: ConvertTime(t.end),
            selectData: timeData,
            command: base,
          },
          {
            id: `${base}heat`,
            section: `Run Timer ${n}`,
            label: 'Allow Heating',
            current: checkRunTimerAllowHeating(t.days) ? 'On' : 'Off',
            selectData: onoffData,
            command: base,
          },
        ];
      })
    : [];

  // useState for selected values instead of plain object
  const [selectValues, setSelectValues] = React.useState({});

  const handleSelectChange = (id, value) => {
    setSelectValues((prev) => ({ ...prev, [id]: value }));
  };

  const sendCommand = (command, value) => {
    fetch(Constants.baseURL + Constants.apiSendCommand, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: String(value),
      }),
      credentials: 'include',
    })
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 8000,
          });
          setTimeout(() => state.refreshDeviceRF(deviceId), 5000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 8000);
        } else {
          toast.error('Send failed. Please try again', {
            position: 'top-right',
            autoClose: 5000,
          });
        }
      })
      .catch((err) => console.log('request failed', err));
  };

  const rows = [
    // General
    {
      id: 'mode',
      section: 'General',
      label: 'MODE',
      current: r4[1] ?? 'N/A',
      selectData: modeData,
      command: 'operationMode',
    },
    {
      id: 'filt',
      section: 'General',
      label: 'FILT',
      current: r6[6] ?? 'N/A',
      selectData: filtData,
      command: 'filtration',
    },
    {
      id: 'wcln',
      section: 'General',
      label: 'WCLN',
      current: ConvertTime(r7[1]),
      selectData: timeData,
      command: 'wcln',
    },
    {
      id: 'ddis',
      section: 'General',
      label: 'D.DIS',
      current:
        r6[19] === '0'
          ? 'WTMP'
          : r6[19] === '1'
            ? 'STMP'
            : r6[19] === '2'
              ? 'TIME'
              : 'N/A',
      selectData: ddisData,
      command: 'ddis',
    },
    {
      id: 'tout',
      section: 'General',
      label: 'T.OUT',
      current: r6[20] ?? 'N/A',
      selectData: toutData,
      command: 'tout',
    },
    {
      id: 'hpmp',
      section: 'General',
      label: 'H.PMP',
      current:
        r7[26] === '0'
          ? 'Auto'
          : r7[26] === '1'
            ? 'Heat'
            : r7[26] === '2'
              ? 'Cool'
              : r7[26] === '3'
                ? 'Off'
                : 'N/A',
      selectData: hpmpData,
      command: 'hpmp',
    },
    {
      id: 'hele',
      section: 'General',
      label: 'H.ELE',
      current: r7[25] === '1' ? 'On' : 'Off',
      selectData: onoffData,
      command: 'hele',
    },

    // Timers (Sleep or Run)
    ...(hasRunTimers
      ? runTimerRows
      : [
        // Sleep Timer 1
        {
          id: 'st1days',
          section: 'Sleep Timer 1',
          label: 'Days',
          current: decodeDays(r6[13]),
          selectData: daysData,
          command: 'st1days',
        },
        {
          id: 'st1bgn',
          section: 'Sleep Timer 1',
          label: 'Begin',
          current: ConvertTime(r6[15]),
          selectData: timeData,
          command: 'st1bgn',
        },
        {
          id: 'st1end',
          section: 'Sleep Timer 1',
          label: 'End',
          current: ConvertTime(r6[17]),
          selectData: timeData,
          command: 'st1end',
        },

        // Sleep Timer 2
        {
          id: 'st2days',
          section: 'Sleep Timer 2',
          label: 'Days',
          current: decodeDays(r6[14]),
          selectData: daysData,
          command: 'st2days',
        },
        {
          id: 'st2bgn',
          section: 'Sleep Timer 2',
          label: 'Begin',
          current: ConvertTime(r6[16]),
          selectData: timeData,
          command: 'st2bgn',
        },
        {
          id: 'st2end',
          section: 'Sleep Timer 2',
          label: 'End',
          current: ConvertTime(r6[18]),
          selectData: timeData,
          command: 'st2end',
        },
      ]),

    // Power Save
    {
      id: 'ps_level',
      section: 'Power Save Timer',
      label: 'Level',
      current:
        r6[10] === '0'
          ? 'Off'
          : r6[10] === '1'
            ? 'Low'
            : r6[10] === '2'
              ? 'High'
              : 'N/A',
      selectData: powersaveData,
      command: 'powersaveLevel',
    },
    {
      id: 'ps_bgn',
      section: 'Power Save Timer',
      label: 'Begin ',
      current: ConvertTime(r6[11]),
      selectData: timeData,
      command: 'powersaveBgn',
    },
    {
      id: 'ps_end',
      section: 'Power Save Timer',
      label: 'End ',
      current: ConvertTime(r6[12]),
      selectData: timeData,
      command: 'powersaveEnd',
    },

    // Keylock
    {
      id: 'lockMode',
      section: 'Keylock',
      label: 'Lock Mode',
      current:
        rg[12] === '0'
          ? 'OFF'
          : rg[12] === '1'
            ? 'PARTIAL'
            : rg[12] === '2'
              ? 'FULL'
              : 'N/A',
      selectData: lockModeData,
      command: 'lockMode',
    },
  ];

  const sections = Array.from(
    new Set(
      rows.map((r) => {
        if (r.section.startsWith('Run Timer')) {
          const timerNumber = r.section.match(/\d+/)?.[0];
          return `Run Timer ${timerNumber}`;
          // const status = getRunTimerEnabledLabel(timerNumber, rh);
          // return `Run Timer ${timerNumber} (${status})`;
        }
        return r.section;
      })
    )
  );

  const handleSend = (rowId, command) => {
    const value = selectValues[rowId];
    if (!value) return;
    sendCommand(command, value);
  };

  const timerIndexMap = {
    1: { days: 1, bgn: 2, end: 3 },
    2: { days: 4, bgn: 5, end: 6 },
    3: { days: 7, bgn: 8, end: 9 },
    4: { days: 10, bgn: 11, end: 12 },
    5: { days: 13, bgn: 14, end: 15 },
    6: { days: 16, bgn: 17, end: 18 },
    7: { days: 19, bgn: 20, end: 21 },
  };

  const handleSendRunTimer = (rowId) => {
    const match = rowId.match(/^rt(\d+)/);
    if (!match) return;

    const timer = Number(match[1]);
    const base = `rt${timer}`;

    const idx = timerIndexMap[timer];

    // DAYS
    const rawDays =
      selectValues[`${base}days`] ??
      parseRunDays(rh[idx.days]);

    const predefined = {
      128: 'Disabled',
      127: 'Every Day (Mon-Sun)',
      62: 'Weekdays (Mon-Fri)',
      65: 'Weekends (Sat-Sun)',
      30: 'Mon-Thu',
      97: 'Fri-Sun',
      2: 'Monday',
      4: 'Tuesday',
      8: 'Wednesday',
      16: 'Thursday',
      32: 'Friday',
      64: 'Saturday',
      1: 'Sunday',
    };

    const daysValue = Object.keys(predefined).find(
      (key) => predefined[key] === rawDays
    );

    const days =
      daysValue !== undefined
        ? Number(daysValue).toString(16).padStart(4, '0').toUpperCase()
        : '0001';

    // BEGIN / END
    const bgn =
      selectValues[`${base}bgn`] ??
      ConvertTime(rh[idx.bgn]);

    const end =
      selectValues[`${base}end`] ??
      ConvertTime(rh[idx.end]);

    // HEAT
    const heat =
      selectValues[`${base}heat`] ??
      (checkRunTimerAllowHeating(rh[idx.days]) ? 'On' : 'Off');

    const payload = `${days}-${bgn}-${end}-${heat}`;

    sendCommand(base, payload);
  };

  const renderTile = (row, idx) => (
    <Grid item xs={12} sm={6} md={4} lg={3} key={`${row.id}-${idx}`}>
      <Paper
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.2,
          position: 'relative',
          transition: 'all 0.2s ease',
          '&:hover': {
            bgcolor: 'rgba(255,255,255,0.06)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        {/* Label and tooltip text now inline */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{ color: 'white', fontWeight: 600, fontSize: 14, lineHeight: 1.1 }}
          >
            {row.label}
          </Typography>

          {USER_MENU_TOOLTIPS[row.label] && (
            <Typography
              sx={{
                fontSize: 13,
                color: 'white',
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                ml: 1,
              }}
            >
              {USER_MENU_TOOLTIPS[row.label]}
            </Typography>
          )}
        </Box>

        <Typography
          variant="caption"
          sx={{
            fontSize: 13,
            color: 'text.disabled',
          }}
        >
          {row.current ?? 'N/A'}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'stretch',
            flexDirection: { xs: 'column', md: 'row' },
            width: '100%',
            minWidth: 0,
            mt: 0.5,

            '--control-h': { xs: '44px', md: '44px' },

            '& .MuiInputBase-root': { height: 'var(--control-h)' },
            '& .MuiSelect-select': {
              height: 'var(--control-h)',
              display: 'flex',
              alignItems: 'center',
              paddingTop: 0,
              paddingBottom: 0,
            },
            '& .MuiFormControl-root': { width: '100%', minWidth: 0 },
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <DynamicSelect
              arrayOfData={row.selectData}
              onSelectChange={(val) => handleSelectChange(row.id, val)}
              id={row.id}
              name=""
            />
          </Box>

          {selectValues[row.id] !== undefined && selectValues[row.id] !== '' && (
            <Button
              onClick={() => row.id.startsWith('rt') ? handleSendRunTimer(row.id)
                : handleSend(row.id, row.command)}
              variant="outlined"
              size="small"
              sx={{
                height: 'var(--control-h)',
                minHeight: 'var(--control-h)',
                textTransform: 'none',
                fontWeight: 600,
                borderColor: 'rgba(255,255,255,0.3)',
                color: 'white',
                px: 1.5,
                width: { xs: '100%', md: 'auto' },
                whiteSpace: 'nowrap',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                },
              }}
            >
              Send
            </Button>
          )}
        </Box>
      </Paper>
    </Grid>
  );


  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        color="white"
        sx={{ fontWeight: 600, mb: 2 }}
      >
        User Menu
      </Typography>

      <Grid container spacing={2}>
        {sections.map((section) => {
          const baseSection = section.replace(/\s\((Enabled|Disabled)\)/, '');

          const sectionRows = rows.filter((r) => {
            if (r.section.startsWith('Run Timer')) {
              const timerNumber = r.section.match(/\d+/)?.[0];
              return `Run Timer ${timerNumber}` === baseSection;
            }
            return r.section === baseSection;
          });

          if (!sectionRows.length) return null;

          return (
            <React.Fragment key={section}>
              <Grid item xs={12} sx={{ mt: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: 'rgba(255,255,255,0.65)', mb: 0.5 }}
                >
                  {section}
                </Typography>
              </Grid>

              {sectionRows.map(renderTile)}
            </React.Fragment>
          );
        })}
      </Grid>
    </>
  );
}

function ConvertTime(value) {
  const v = Number(value);
  const hours = v >> 8;
  const minutes = v & 0xff;

  const hoursString = hours < 10 ? '0' + hours : String(hours);
  const minutesString = minutes < 10 ? '0' + minutes : String(minutes);

  return `${hoursString}:${minutesString}`;
}

function decodeDays(codeStr) {
  const code = Number(codeStr);
  if (code === 1) return 'Friday';
  if (code === 2) return 'Thursday';
  if (code === 4) return 'Wednesday';
  if (code === 8) return 'Tuesday';
  if (code === 16) return 'Monday';
  if (code === 32) return 'Sunday';
  if (code === 64) return 'Saturday';
  if (code === 127) return 'All week';
  if (code === 96) return 'Weekend';
  if (code === 31) return 'Weekdays';
  if (code === 128 || code === 0) return 'Disabled';
  return 'Disabled';
}

const timerIndexMap = {
  1: { days: 1, bgn: 2, end: 3 },
  2: { days: 4, bgn: 5, end: 6 },
  3: { days: 7, bgn: 8, end: 9 },
  4: { days: 10, bgn: 11, end: 12 },
  5: { days: 13, bgn: 14, end: 15 },
  6: { days: 16, bgn: 17, end: 18 },
  7: { days: 19, bgn: 20, end: 21 },
};

const predefined = {
  128: 'Disabled',
  127: 'Every Day (Mon-Sun)',
  62: 'Weekdays (Mon-Fri)',
  65: 'Weekends (Sat-Sun)',
  30: 'Mon-Thu',
  97: 'Fri-Sun',
  2: 'Monday',
  4: 'Tuesday',
  8: 'Wednesday',
  16: 'Thursday',
  32: 'Friday',
  64: 'Saturday',
  1: 'Sunday',
};

function parseRunDays(rhValue) {
  if (rhValue === undefined || rhValue === null || rhValue === '') return 'UNKNOWN';

  const intValue = Number(rhValue);

  if (isNaN(intValue)) return 'UNKNOWN';

  const hex = intValue.toString(16);

  const daysInt = parseInt(hex, 16) & 0x7f;

  if (predefined[daysInt]) {
    return predefined[daysInt];
  }

  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  for (let i = 0; i < 7; i++) {
    if (daysInt === (1 << i)) {
      return days[i];
    }
  }

  return 'UNKNOWN';
}

function checkRunTimerAllowHeating(value) {
  return (Number(value) & (1 << (15 - 8))) !== 0;
}

function getRunTimerEnabledLabel(timerNumber, rh) {
  const baseIndexMap = {
    1: 1,
    2: 4,
    3: 7,
    4: 10,
    5: 13,
    6: 16,
    7: 19,
  };

  const idx = baseIndexMap[timerNumber];
  if (idx === undefined) return 'Disabled';

  const raw = Number(rh?.[idx] ?? 0);

  const isEnabled = (raw & (1 << 8)) !== 0;

  return isEnabled ? 'Enabled' : 'Disabled';
}